export enum WaitCondition {
	PLAYER_INSPECTING_WEAPON,
	OPENED_AUGMENT_UI,
	PLAYER_CLICKED_ATTACH_AUG,
	PLAYER_ATTACHED_AUGMENT,
}
